


















































































































































































































































































































































































































































































































import VueRoot from 'vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import AscendingIcon from '@/app/ui/assets/ascending_icon.vue'
import Loading from '@/app/ui/components/Loading/index.vue'
import { Utils } from '@/app/infrastructures/misc'
import controller from '@/app/ui/controllers/PickupController'
import dayjs from 'dayjs'
import dayjsDuration from 'dayjs/plugin/duration'
import {
  Pickup,
  PickupCRROTWV2BucketKey,
  PickupCRROTWV2Group,
  PickupCRROTWV2List,
  PickupCRROTWV2Summary,
  PICKUP_CRROTW_V2_BUCKET_KEYS,
} from '@/domain/entities/Pickup'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import {
  IOptions,
  ITableCell,
  ParametersV2,
} from '@/data/infrastructures/misc/interfaces/pickupCRROTW'
import {
  SortFieldsCRROTWV2,
  SortTypeCRROTW,
} from '@/app/infrastructures/misc/Constants/pickup'
import {
    CRROTW_CANCEL_GROUP_STORAGE_KEY,
  CRROTW_MARK_DONE_GROUP_STORAGE_KEY,
  isCorporateCrrotwShipmentType,
  serializeCrrotwGroupForCancel,
  serializeCrrotwGroupForMarkDone,
} from '@/app/infrastructures/misc/pickupCrrotw'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import IconSync from '@/app/ui/assets/icon_sync.vue'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import PriorityIcon from '@/app/ui/assets/ics_f_priority-fast.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import { Pagination } from '@/domain/entities/Pagination'
import DropdownMultiSelect from '../components/DropdownMultiSelect/index.vue'
import {
  DataObject,
  HeaderObject,
  SortValueObject,
} from '@/app/ui/components/DataTableV2/type'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import { ExportPickupRequest } from '@/data/payload/api/PickupRequest'
import { ManageCourier } from '@/domain/entities/ManageCourier'
import ShipmentListModal from './components/ShipmentListModal.vue'
import TransferPickupModal from './components/TransferPickupModal.vue'
import TransferPickupSuccessModal from './components/TransferPickupSuccessModal.vue'
import ModalCrrotwTaskGroupCancelReason from './components/ModalCrrotwTaskGroupCancelReason.vue'
import CrrotwTaskGroupCancelFeedbackModal from './components/CrrotwTaskGroupCancelFeedbackModal.vue'
import { FlagsAccount } from '@/feature-flags'
import FleetAppFilterButton from '@/app/ui/views/Pickup/components/FleetAppFilterButton/index.vue';

dayjs.extend(dayjsDuration)

const CRROTW_SHIPMENT_TYPE_LABELS: Record<string, string> = {
  delivery_order: 'Delivery Order',
  marketplace: 'Marketplace',
  customer: 'Customer App',
  corporate: 'Corporate',
  aggregator: 'Aggregator',
  cod_balikan: 'COD Balikan',
}

const CRROTW_V2_STRIP_LABELS: Record<PickupCRROTWV2BucketKey, string> = {
  '0_1h': '0-1 Jam',
  '1_2h': '1-2 Jam',
  '2_3h': '2-3 Jam',
  '3_4h': '3-4 Jam',
  '4_5h': '4-5 Jam',
  '5_plus': '5++ Jam',
}

@Component({
  components: {
    TextInput,
    DataTableV2,
    AscendingIcon,
    Loading,
    PaginationNav,
    DropdownSelect,
    Button,
    IconSync,
    IconWhatsApp,
    EyeIcon,
    EyeDisabledIcon,
    PriorityIcon,
    LoadingOverlay,
    DropdownMultiSelect,
    WidgetDownload,
    ShipmentListModal,
    TransferPickupModal,
    TransferPickupSuccessModal,
    ModalCrrotwTaskGroupCancelReason,
    CrrotwTaskGroupCancelFeedbackModal,
    FleetAppFilterButton
  },
})
class PickupCRROTWPage extends Vue {
  controller = controller

  crrotwV2BucketKeys = PICKUP_CRROTW_V2_BUCKET_KEYS
  crrotwV2BucketStripLabels = CRROTW_V2_STRIP_LABELS

  enumSelectedSort = SortTypeCRROTW
  enumSortFields = SortFieldsCRROTWV2

  crrotwTableSlotNames = [
    'checkbox',
    '',
    'sender',
    'totalkoli',
    'address',
    'jenisHdr',
    'posHdr',
    'couriercell',
    'crrotwtime',
    '',
    '',
    'atur',
  ]

  headers = [
    this.headerCellMapper('', '44px'),
    this.headerCellMapper('No.', '60px'),
    this.headerCellMapper(
      'Nama Pengirim',
      '200px',
      true,
      SortFieldsCRROTWV2.CUSTOMER_NAME,
      '20px'
    ),
    this.headerCellMapper(
      'Total Shipment (koli)',
      '200px',
      true,
      SortFieldsCRROTWV2.TOTAL_SHIPMENTS,
      '20px'
    ),
    this.headerCellMapper('Alamat', '260px'),
    this.headerCellMapper('Jenis Shipment', '190px'),
    this.headerCellMapper('Nama POS', '190px'),
    this.headerCellMapper(
      'Nama Kurir',
      '225px',
      true,
      SortFieldsCRROTWV2.COURIER_NAME,
      '20px'
    ),
    this.headerCellMapper('Waktu CRROTW', '180px', false, SortFieldsCRROTWV2.LAST_UPDATED),
    this.headerCellMapper(
      'Durasi Pick Up (SHPCRT)',
      '210px',
      true,
      SortFieldsCRROTWV2.PICKUP_DURATION_SHPCRT,
      '16px'
    ),
    this.headerCellMapper(
      'Durasi Pick Up (First CRRSRC)',
      '300px',
      true,
      SortFieldsCRROTWV2.PICKUP_DURATION_FIRST_CRRSRC,
      '16px'
    ),
    this.headerCellMapper('Atur', '96px'),
  ]

  selectedSort: SortTypeCRROTW | null = null
  parameters: ParametersV2 = {
    page: 1,
    perPage: 10,
    search: '',
    shipmentType: [],
    pickupDuration: {
      label: 'Semua',
      value: 'all',
    },
    sort: <SortValueObject>{
      name: 'crrotw_at',
      direction: 'DESC',
    },
  }

  shipmentTypeOptions = [
    {
      label: 'Marketplace (MP)',
      value: 'marketplace',
    },
    {
      label: 'Customer Apps (CA)',
      value: 'customer',
    },
    {
      label: 'Corporate',
      value: 'corporate',
    },
    {
      label: 'Aggregator (C1)',
      value: 'aggregator',
    },
    {
      label: 'Delivery Order (DO)',
      value: 'delivery_order',
    },
  ]

  pickupDurationOptions = [
    {
      label: 'Semua',
      value: 'all',
    },
    {
      label: '0-1 Jam',
      value: '0_1h',
    },
    {
      label: '1-2 Jam',
      value: '1_2h',
    },
    {
      label: '2-3 Jam',
      value: '2_3h',
    },
    {
      label: '3-4 Jam',
      value: '3_4h',
    },
    {
      label: '4-5 Jam',
      value: '4_5h',
    },
    {
      label: '5++ Jam',
      value: '5_plus',
    },
  ]

  tableData: ITableCell[][] = []

  selectedRowKeys: string[] = []

  openAturMenuTaskId: number | null = null

  isFleetApp = ''
  executionPlatform = ''

  /** Fixed flyout escapes DataTableV2 overflow-x clipping. */
  private aturMenuTriggerEl: HTMLElement | null = null

  aturMenuFixedStyle: Record<string, string> = {}

  private aturTableScrollEl: Element | null = null

  private readonly aturMenuMinWidthPx = 176

  private boundRepositionAturMenu = (): void => {
    this.updateAturMenuFixedPosition()
  }

  shipmentListModalVisible = false

  shipmentListModalGroup: PickupCRROTWV2Group | null = null

  transferModalVisible = false
  transferSuccessVisible = false
  transferModalTaskGroupIds: number[] = []
  transferCourierOptions: IOptions[] = []
  transferCouriersLoading = false
  transferSubmitting = false

  markDoneModalVisible = false
  markDoneSuccessVisible = false
  markDoneModalRowKeys: string[] = []
  markDoneSubmitting = false

  taskGroupCancelReasonVisible = false
  taskGroupCancelSubmitting = false
  taskGroupCancelStatusLabel = 'CRRCNC'
  taskGroupCancelTaskGroupId: number | null = null
  taskGroupCancelFirstShipmentId: string | null = null

  taskGroupCancelFeedbackVisible = false
  taskGroupCancelFeedbackVariant: 'success' | 'error' = 'success'
  taskGroupCancelFeedbackMessage = ''
  taskGroupCancelFeedbackFlow:
    | 'crrcnc_navigate'
    | 'crrcnc_no_shipment'
    | 'crrnfd'
    | 'none' = 'none'

  crrotwTick = Date.now()

  private crrotwCountdownTimer: number | null = null

  perPageOptions: IOptions[] = [
    { label: '10', value: 10 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ]

  pagination = new Pagination()

  created(): void {
    this.fetchPickups(true, true)
  }

  mounted(): void {
    document.addEventListener('click', this.closeAturMenus)
    window.addEventListener('resize', this.boundRepositionAturMenu)
    window.addEventListener('scroll', this.boundRepositionAturMenu, true)
    this.crrotwCountdownTimer = window.setInterval(() => {
      this.crrotwTick = Date.now()
    }, 1000)
  }

  beforeDestroy(): void {
    document.removeEventListener('click', this.closeAturMenus)
    window.removeEventListener('resize', this.boundRepositionAturMenu)
    window.removeEventListener('scroll', this.boundRepositionAturMenu, true)
    this.unbindAturTableScrollListener()
    if (this.crrotwCountdownTimer != null) {
      window.clearInterval(this.crrotwCountdownTimer)
    }
  }

  public getRowKey(g: PickupCRROTWV2Group): string {
    if (g.taskGroupId > 0) {
      return String(g.taskGroupId)
    }
    return g.shipments?.[0]?.shipmentId ?? g.shipperHash ?? ''
  }

  get pageRowKeys(): string[] {
    return (this.controller.pickupCRROTWV2Data.data ?? []).map(g => this.getRowKey(g))
  }

  get isAllPageSelected(): boolean {
    const keys = this.pageRowKeys
    return (
      keys.length > 0 &&
      keys.every(k => this.selectedRowKeys.includes(k))
    )
  }

  get isSomePageSelected(): boolean {
    const keys = this.pageRowKeys
    return keys.some(k => this.selectedRowKeys.includes(k))
  }

  get headerCheckboxIndeterminate(): boolean {
    return this.isSomePageSelected && !this.isAllPageSelected
  }

  get bulkToolbarTransferDisabled(): boolean {
    if (this.selectedRowKeys.length === 0) return true
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    return this.selectedRowKeys.some(key => {
      const g = rows.find(r => this.getRowKey(r) === key)
      const isIdFleetApp = g?.executionPlatform === 'FLEET_APPS' || (g != null && g.taskGroupId <= 0)

      return (
        g == null ||
        isCorporateCrrotwShipmentType(g.shipmentType) ||
        isIdFleetApp
      )
    })
  }

  get markDoneModalSummary(): {
    senderCount: number
    totalShipments: number
    totalKoli: number
  } {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    let totalShipments = 0
    let totalKoli = 0
    let senderCount = 0
    for (const key of this.markDoneModalRowKeys) {
      const g = rows.find(r => this.getRowKey(r) === key)
      if (g) {
        senderCount += 1
        totalShipments += g.totalShipments ?? 0
        totalKoli += g.totalQuantity ?? 0
      }
    }
    return { senderCount, totalShipments, totalKoli }
  }

  get selectedTaskGroupIds(): number[] {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    return this.selectedRowKeys
      .map(k => rows.find(r => this.getRowKey(r) === k)?.taskGroupId)
      .filter((id): id is number => typeof id === 'number' && id > 0)
  }

  get transferModalSummary(): {
    senderCount: number
    totalShipments: number
    totalKoli: number
  } {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    let totalShipments = 0
    let totalKoli = 0
    let senderCount = 0
    for (const id of this.transferModalTaskGroupIds) {
      const g = rows.find(r => r.taskGroupId === id)
      if (g) {
        senderCount += 1
        totalShipments += g.totalShipments ?? 0
        totalKoli += g.totalQuantity ?? 0
      }
    }
    return { senderCount, totalShipments, totalKoli }
  }

  get crrotwTransferNotInCourierIds(): number[] {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    const set = new Set<number>()
    for (const id of this.transferModalTaskGroupIds) {
      const g = rows.find(r => r.taskGroupId === id)
      const cid = g?.courier?.id
      if (cid != null && cid > 0) {
        set.add(cid)
      }
    }
    return [...set]
  }

  get aturFlyoutRowIsCorporate(): boolean {
    const id = this.openAturMenuTaskId
    if (id == null) return true
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    const g = rows.find(r => r.taskGroupId === id)
    if (!g) return true
    return isCorporateCrrotwShipmentType(g.shipmentType)
  }

  get isMyWhitelist() {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  @Watch('isMyWhitelist')
  isMyWhitelistChanged() {
    this.fetchPickups(true, true);
  }

  get params(): Record<string, string | number | boolean> {
    const pd =
      this.parameters.pickupDuration?.value === 'all'
        ? ''
        : <string>this.parameters.pickupDuration?.value
    return {
      page: this.parameters.page,
      perPage: this.parameters.perPage,
      keyword: this.parameters.search,
      dateFrom: this.dateFrom(),
      syncSummary: false,
      shipmentType: <string>(
        this.parameters.shipmentType
          ?.map(
            type =>
              this.shipmentTypeOptions.find(option => option.label === type)
                ?.value
          )
          .join(',')
      ),
      durationBucket: pd,
      sortDirection: <string>this.parameters.sort.direction,
      column: <string>this.parameters.sort.name,
      originCountry: this.isMyWhitelist ? 'Malaysia' : '',
      executionPlatform: this.isFleetApp
    }
  }

  get minDate(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 7))
  }

  get isexportPickupListLoading(): boolean {
    return controller.isExportCRROTWLoading
  }

  get pickupData(): Pickup[] {
    return controller.pickupData
  }

  get statusId(): string {
    return <string>this.$route.meta.additional.statusId
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get summaryV2(): PickupCRROTWV2Summary {
    return controller.pickupCRROTWSummaryV2
  }

  get latestSync(): string {
    if (!controller.latestSync) {
      return ''
    }

    return `${dayjs(controller.latestSync).format('DD-MM-YY, HH:mm')} WIB`
  }

  public onFilterShipmentType(value: string[]): void {
    this.parameters.shipmentType = value
    this.fetchPickups(true, true)
  }

  public onFilterPickupDuration(value: { label: string; value: string }): void {
    if (!value) {
      this.parameters.pickupDuration = {
        label: 'Semua',
        value: 'all',
      }
    }
    this.fetchPickups(true, true)
  }

  public dateFrom(): string {
    return dayjs()
      .subtract(1, 'week')
      .format('YYYY-MM-DD')
  }

  public onFleetApp(value: string) {
    this.isFleetApp = value

    this.fetchPickups(true, true)
  }

  fetchPickups(reset: boolean, sync = false): void {
    if (reset) {
      this.parameters.page = 1
      this.selectedRowKeys = []
      this.closeAturFlyout()
    }

    const payload = { ...this.params }

    payload.syncSummary = sync

    if (!this.parameters.search) {
      delete payload.keyword
    }

    controller.getPickupCRROTWV2(payload)
  }

  public fetchPickupsPerPage(perPage: number): void {
    this.parameters.perPage = perPage
    this.fetchPickups(true)
  }

  public onSearch = Utils.debounce((search: string): void => {
    if (search.length > 2 || search.length === 0) {
      this.fetchPickups(true, true)
    }
  }, 500)

  @Watch('parameters.page')
  @Watch('parameters.perPage')
  private clearRowSelectionOnPaginationChange(): void {
    this.selectedRowKeys = []
    this.closeAturFlyout()
  }

  @Watch('headerCheckboxIndeterminate')
  private syncSelectAllCheckboxIndeterminate(): void {
    this.$nextTick(() => {
      const r = this.$refs.crrotwSelectAllCheckbox as
        | HTMLInputElement
        | HTMLInputElement[]
        | undefined
      const el = Array.isArray(r) ? r[0] : r
      if (el) {
        el.indeterminate = this.headerCheckboxIndeterminate
      }
    })
  }

  public onToggleSelectAll(ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    const pageKeys = this.pageRowKeys
    if (checked) {
      const merged = new Set([...this.selectedRowKeys, ...pageKeys])
      this.selectedRowKeys = [...merged]
    } else {
      const drop = new Set(pageKeys)
      this.selectedRowKeys = this.selectedRowKeys.filter(
        k => !drop.has(k)
      )
    }
  }

  public onToggleRowCheckbox(rowKey: string, ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    if (checked) {
      if (!this.selectedRowKeys.includes(rowKey)) {
        this.selectedRowKeys = [...this.selectedRowKeys, rowKey]
      }
    } else {
      this.selectedRowKeys = this.selectedRowKeys.filter(
        k => k !== rowKey
      )
    }
  }

  public isRowSelected(rowKey: string): boolean {
    return this.selectedRowKeys.includes(rowKey)
  }

  public closeAturMenus(): void {
    this.closeAturFlyout()
  }

  private closeAturFlyout(): void {
    this.unbindAturTableScrollListener()
    this.openAturMenuTaskId = null
    this.aturMenuTriggerEl = null
    this.aturMenuFixedStyle = {}
    this.executionPlatform = ''
  }

  private updateAturMenuFixedPosition(): void {
    if (!this.aturMenuTriggerEl || this.openAturMenuTaskId == null) {
      return
    }
    const r = this.aturMenuTriggerEl.getBoundingClientRect()
    const w = this.aturMenuMinWidthPx
    const pad = 4
    let left = r.right - w
    const maxLeft = window.innerWidth - w - 8
    left = Math.max(8, Math.min(left, maxLeft))
    const top = r.bottom + pad
    this.aturMenuFixedStyle = {
      top: `${top}px`,
      left: `${left}px`,
    }
  }

  private bindAturTableScrollListener(): void {
    this.unbindAturTableScrollListener()
    const el = document.querySelector(
      '[data-testid="global-component-table-v2"]'
    )
    if (el) {
      this.aturTableScrollEl = el
      el.addEventListener('scroll', this.boundRepositionAturMenu, {
        passive: true,
      })
    }
  }

  private unbindAturTableScrollListener(): void {
    if (this.aturTableScrollEl) {
      this.aturTableScrollEl.removeEventListener(
        'scroll',
        this.boundRepositionAturMenu
      )
      this.aturTableScrollEl = null
    }
  }

  public onAturMenuToggle(taskGroupId: number, ev: MouseEvent, executionPlatform: string): void {
    if(executionPlatform !== '') {
      this.executionPlatform = executionPlatform
    }

    if (this.openAturMenuTaskId === taskGroupId) {
      this.closeAturFlyout()
      return
    }
    this.openAturMenuTaskId = taskGroupId
    this.aturMenuTriggerEl = ev.currentTarget as HTMLElement
    this.$nextTick(() => {
      this.updateAturMenuFixedPosition()
      this.bindAturTableScrollListener()
    })
  }

  public onAturFlyoutAction(action: string): void {
    const id = this.openAturMenuTaskId
    if (id == null) return
    this.onAturRowAction(action, id)
  }

  public onAturRowAction(action: string, taskGroupId: number): void {
    this.closeAturFlyout()
    if (action === 'Transfer Pick Up') {
      void this.openTransferPickUpModal([taskGroupId])
      return
    }
    if (action === 'Tandai Selesai') {
      const rows = this.controller.pickupCRROTWV2Data.data ?? []
      const g = rows.find(r => r.taskGroupId === taskGroupId)
      if (!g) {
        VueRoot.notify({
          title: 'CRROTW',
          text: 'Data grup tidak ditemukan.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      try {
        sessionStorage.setItem(
          CRROTW_MARK_DONE_GROUP_STORAGE_KEY,
          JSON.stringify(serializeCrrotwGroupForMarkDone(g))
        )
      } catch {
        /* ignore quota / private mode */
      }
      this.$router.push({
        name: 'PickupCRROTWTaskGroupMarkAsDone_V2',
        params: { taskGroupId: String(taskGroupId) },
      })
      return
    }
    if (action === 'Cancel Shipment') {
      const rows = this.controller.pickupCRROTWV2Data.data ?? []
      const g = rows.find(r => r.taskGroupId === taskGroupId)
      if (!g) {
        VueRoot.notify({
          title: 'CRROTW',
          text: 'Data grup tidak ditemukan.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      try {
        sessionStorage.setItem(
          CRROTW_CANCEL_GROUP_STORAGE_KEY,
          JSON.stringify(serializeCrrotwGroupForCancel(g))
        )
      } catch {
        /* ignore quota / private mode */
      }
      this.$router.push({
        name: 'PickupCRROTWTaskGroupCancelShipment_V2',
        params: { taskGroupId: String(taskGroupId) },
      })
      return
    }
    if (action === 'Ubah ke CRRNFD' || action === 'Ubah ke CRRCNC') {
      const rows = this.controller.pickupCRROTWV2Data.data ?? []
      const g = rows.find(r => r.taskGroupId === taskGroupId)
      if (!g) {
        VueRoot.notify({
          title: 'CRROTW',
          text: 'Data grup tidak ditemukan.',
          type: 'error',
          duration: 5000,
        })
        return
      }
      const label = action === 'Ubah ke CRRNFD' ? 'CRRNFD' : 'CRRCNC'
      this.openTaskGroupStatusChangeModal(taskGroupId, label, g)
      return
    }
  }

  private openTaskGroupStatusChangeModal(
    taskGroupId: number,
    statusLabel: 'CRRNFD' | 'CRRCNC',
    group: PickupCRROTWV2Group
  ): void {
    const first = group.shipments?.[0]
    const sid = first?.shipmentId?.trim() || null
    this.taskGroupCancelTaskGroupId = taskGroupId
    this.taskGroupCancelStatusLabel = statusLabel
    this.taskGroupCancelFirstShipmentId = sid && sid.length > 0 ? sid : null
    this.taskGroupCancelReasonVisible = true
  }

  public closeTaskGroupCancelReasonModal(): void {
    if (this.taskGroupCancelSubmitting) return
    this.taskGroupCancelReasonVisible = false
    this.taskGroupCancelTaskGroupId = null
    this.taskGroupCancelFirstShipmentId = null
  }

  public async onTaskGroupCancelReasonConfirm(reason: string): Promise<void> {
    const taskGroupId = this.taskGroupCancelTaskGroupId
    const label = this.taskGroupCancelStatusLabel
    const firstShipmentId = this.taskGroupCancelFirstShipmentId
    if (taskGroupId == null) return
    this.taskGroupCancelSubmitting = true
    this.taskGroupCancelReasonVisible = false
    try {
      await controller.cancelCrrotwTaskGroupAdmin({
        taskGroupId,
        reason,
        restartNearestCourier: label === 'CRRNFD',
      })
      if (label === 'CRRCNC') {
        if (firstShipmentId) {
          this.taskGroupCancelFeedbackVariant = 'success'
          this.taskGroupCancelFeedbackMessage = 'Berhasil Mengubah ke CRRCNC'
          this.taskGroupCancelFeedbackFlow = 'crrcnc_navigate'
        } else {
          this.taskGroupCancelFeedbackVariant = 'success'
          this.taskGroupCancelFeedbackMessage =
            'Berhasil Mengubah ke CRRCNC.\n\nShipment ID untuk halaman Detail Cancel tidak tersedia. Daftar akan disegarkan setelah Anda mengetuk OKE.'
          this.taskGroupCancelFeedbackFlow = 'crrcnc_no_shipment'
        }
      } else {
        this.taskGroupCancelFeedbackVariant = 'success'
        this.taskGroupCancelFeedbackMessage = 'Berhasil Mengubah ke CRRNFD'
        this.taskGroupCancelFeedbackFlow = 'crrnfd'
      }
      this.taskGroupCancelFeedbackVisible = true
    } catch (error: unknown) {
      const err = error as {
        status?: number
        data?: { message?: { en?: string } }
        error?: { message?: { en?: string } }
      }
      const en =
        err?.data?.message?.en ?? err?.error?.message?.en ?? ''
      VueRoot.notify({
        title: 'Cancel Pickup Failed',
        text:
          this.taskGroupCancelFeedbackMessage =
          err?.status === 400 ||
          err?.status === 422 ||
          err?.status === 404
            ? String(en || 'Permintaan tidak dapat diproses.')
            : 'Terjadi kesalahan. Silakan coba lagi.',
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.taskGroupCancelSubmitting = false
    }
  }

  public onTaskGroupCancelFeedbackClose(): void {
    this.taskGroupCancelFeedbackVisible = false
    const flow = this.taskGroupCancelFeedbackFlow
    const sid = this.taskGroupCancelFirstShipmentId
    this.taskGroupCancelFeedbackFlow = 'none'
    this.taskGroupCancelFeedbackMessage = ''
    this.taskGroupCancelTaskGroupId = null
    this.taskGroupCancelFirstShipmentId = null

    if (
      flow === 'crrcnc_navigate' ||
      flow === 'crrcnc_no_shipment' ||
      flow === 'crrnfd'
    ) {
      this.fetchPickups(true, true)
    }
  }

  public onBulkTransferPickUp(): void {
    if (this.bulkToolbarTransferDisabled) return
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    const taskGroupIds = this.selectedRowKeys
      .map(k => rows.find(r => this.getRowKey(r) === k)?.taskGroupId)
      .filter((id): id is number => typeof id === 'number' && id > 0)
    void this.openTransferPickUpModal(taskGroupIds)
  }

  private formatCrrotwTransferCourierLabel(c: ManageCourier): string {
    const id = c.courierId ?? ''
    const name = c.fullName ?? ''
    const typ = String(c.courierType ?? '').trim() || '—'
    const phone = this.formatPhoneDisplay(String(c.phoneNumber ?? ''))
    const phonePart = phone ? ` ${phone}` : ''
    return `[${id}] ${name} (${typ})${phonePart}`
  }

  public async openTransferPickUpModal(taskGroupIds: number[]): Promise<void> {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    const eligible = taskGroupIds.filter(id => {
      const g = rows.find(r => r.taskGroupId === id)
      return g != null && !isCorporateCrrotwShipmentType(g.shipmentType)
    })
    if (eligible.length === 0) {
      VueRoot.notify({
        title: 'Transfer Pick Up',
        text: 'Tidak ada grup non-corporate yang dapat ditransfer.',
        type: 'warn',
        duration: 4500,
      })
      return
    }
    this.transferModalTaskGroupIds = eligible
    this.transferCourierOptions = []
    this.transferModalVisible = true
    this.transferCouriersLoading = true
    try {
      const list = await controller.fetchCrrotwTransferCourierOptions(
        this.crrotwTransferNotInCourierIds
      )
      this.transferCourierOptions = list.map(c => ({
        label: this.formatCrrotwTransferCourierLabel(c),
        value: <number>c.courierId,
      }))
    } catch (error: unknown) {
      const err = error as {
        status?: number
        error?: { message?: { en?: string } }
      }
      VueRoot.notify({
        title: 'Daftar kurir',
        text:
          err?.status === 400 || err?.status === 422 || err?.status === 404
            ? String(err?.error?.message?.en ?? '')
            : 'Gagal memuat daftar kurir.',
        type: 'error',
        duration: 5000,
      })
      this.transferModalVisible = false
    } finally {
      this.transferCouriersLoading = false
    }
  }

  public closeTransferPickUpModal(): void {
    if (this.transferSubmitting) return
    this.transferModalVisible = false
    this.transferModalTaskGroupIds = []
  }

  public closeTransferSuccessModal(): void {
    this.transferSuccessVisible = false
  }

  public async onTransferPickUpConfirm(courierId: number): Promise<void> {
    this.transferModalVisible = false
    this.transferSubmitting = true
    try {
      const outcomes = await controller.submitCrrotwDashboardPickupTransfer({
        taskGroupIds: [...this.transferModalTaskGroupIds],
        courierId,
      })
      const failed = outcomes.filter(o => !o.status)
      const ok = outcomes.filter(o => o.status)
      this.transferModalVisible = false
      this.transferModalTaskGroupIds = []
      if (failed.length === 0) {
        this.transferSuccessVisible = true
      } else if (ok.length === 0) {
        VueRoot.notify({
          title: 'Transfer Pick Up',
          text: `Gagal untuk semua grup (task_group_id: ${failed
            .map(f => f.taskGroupId)
            .join(', ')}).`,
          type: 'error',
          duration: 6000,
        })
      } else {
        VueRoot.notify({
          title: 'Transfer Pick Up',
          text: `Sebagian berhasil (${ok.length} grup). Gagal: ${failed
            .map(f => f.taskGroupId)
            .join(', ')}.`,
          type: 'warn',
          duration: 8000,
        })
      }
      this.selectedRowKeys = []
      this.fetchPickups(true, true)
    } catch (error: unknown) {
      const err = error as {
        status?: number
        error?: { message?: { en?: string } }
      }
      VueRoot.notify({
        title: 'Transfer Pick Up',
        text:
          err?.status === 400 ||
          err?.status === 422 ||
          err?.status === 403 ||
          err?.status === 404
            ? String(err?.error?.message?.en ?? 'Validasi gagal.')
            : 'Transfer pick up gagal.',
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.transferSubmitting = false
    }
  }

  public onBulkTandaiSelesai(): void {
    if (this.selectedRowKeys.length === 0) return
    this.markDoneModalRowKeys = [...this.selectedRowKeys]
    this.markDoneModalVisible = true
  }

  public closeMarkDoneModal(): void {
    if (this.markDoneSubmitting) return
    this.markDoneModalVisible = false
    this.markDoneModalRowKeys = []
  }

  public closeMarkDoneSuccessModal(): void {
    this.markDoneSuccessVisible = false
  }

  public async onBulkMarkDoneConfirm({ hubPersonName, personName }: { hubPersonName: string, personName: string }): Promise<void> {
    if (this.markDoneSubmitting) return
    this.markDoneSubmitting = true
    try {
      const rows = this.controller.pickupCRROTWV2Data.data ?? []
      const taskGroupIds: number[] = []
      const shipmentIds: string[] = []

      for (const key of this.markDoneModalRowKeys) {
        const g = rows.find(r => this.getRowKey(r) === key)
        if (!g) continue
        if (g.taskGroupId > 0) {
          taskGroupIds.push(g.taskGroupId)
        } else if (g.shipments) {
          shipmentIds.push(...g.shipments.map(s => s.shipmentId))
        }
      }

      const ok = await controller.submitCrrotwAdminTaskPickupDone({
        taskGroupIds,
        shipmentIds: shipmentIds.length > 0 ? shipmentIds : undefined,
        hubPersonName,
        personName
      })
      if (ok) {
        this.markDoneModalVisible = false
        this.markDoneModalRowKeys = []
        this.markDoneSuccessVisible = true
        this.selectedRowKeys = []
        this.fetchPickups(true, true)
      }
    } finally {
      this.markDoneSubmitting = false
    }
  }

  public onTotalShipmentKoliClick(taskGroupId: number): void {
    this.openShipmentListModal(taskGroupId)
  }

  public openShipmentListModal(taskGroupId: number): void {
    const rows = this.controller.pickupCRROTWV2Data.data ?? []
    const g = rows.find(r => r.taskGroupId === taskGroupId)
    if (!g) return
    this.shipmentListModalGroup = g
    this.shipmentListModalVisible = true
  }

  public closeShipmentListModal(): void {
    this.shipmentListModalVisible = false
    this.shipmentListModalGroup = null
  }

  public mapsHref(address: string): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address || ''
    )}`
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public waCourierHref(phone: string, sampleShipmentId: string): string {
    const d = this.waDigits(phone)
    const sid = sampleShipmentId || ''
    const q = encodeURIComponent(
      `Hi Bapak/Ibu, kami ingin menanyakan Shipment ID ${sid}`
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public isMultiDriver(data: { executionPlatform?: string; courierName?: string }): boolean {
    return Boolean(
      data &&
      data.executionPlatform === 'FLEET_APPS' &&
      data.courierName &&
      data.courierName.indexOf(',') !== -1
    )
  }

  public courierCellTitle(data: { executionPlatform?: string; courierName?: string; courierId?: number; courierPhone?: string }): string {
    if (this.isMultiDriver(data)) {
      if (!data?.courierPhone) {
        return (data.courierName || '').replace(/\(\+?[0-9]+\)/g, '(********)')
      }
      return data.courierName || ''
    }
    if (data && data.executionPlatform === 'FLEET_APPS' && data.courierName && data.courierName.startsWith('[')) {
      return data.courierName
    }
    return `[${data?.courierId || ''}] ${data?.courierName || ''}`
  }

  public shouldShowCourierPhoneRow(data: { executionPlatform?: string; courierName?: string }): boolean {
    if (!data || data.executionPlatform !== 'FLEET_APPS') return true
    return !(data.courierName && data.courierName.indexOf(',') !== -1)
  }

  public shipmentTypeLabel(code: string): string {
    const key = String(code || '')
      .toLowerCase()
      .trim()
    return CRROTW_SHIPMENT_TYPE_LABELS[key] || code || '—'
  }

  public formatCrrotwDurationMinutes(totalMin: number): string {
    const n = Math.max(0, Math.floor(Number(totalMin) || 0))
    const d = Math.floor(n / (24 * 60))
    const h = Math.floor((n % (24 * 60)) / 60)
    const m = n % 60
    const parts: string[] = []
    if (d) parts.push(`${d}d`)
    if (h) parts.push(`${h}h`)
    parts.push(`${m}m`)
    return parts.join(' ')
  }

  public crrotwMinutesToExpiry(expiredAt: string): number {
    if (!expiredAt) return Number.POSITIVE_INFINITY
    const end = dayjs(expiredAt)
    return end.diff(dayjs(this.crrotwTick), 'minute', true)
  }

  public isCrrotwSlaUrgent(expiredAt: string): boolean {
    const m = this.crrotwMinutesToExpiry(expiredAt)
    return m >= 0 && m < 30
  }

  public shouldShowCrrotwCountdown(expiredAt: string): boolean {
    if (!expiredAt) return false
    return dayjs(expiredAt).valueOf() > this.crrotwTick
  }

  public formatCrrotwCountdown(expiredAt: string): string {
    if (!expiredAt) return '—'
    const end = dayjs(expiredAt).valueOf()
    const ms = end - this.crrotwTick
    if (ms <= 0) return '00 : 00 : 00'
    const totalSec = Math.floor(ms / 1000)
    const h = Math.floor(totalSec / 3600)
    const mi = Math.floor((totalSec % 3600) / 60)
    const s = totalSec % 60
    const pad = (x: number) => String(x).padStart(2, '0')
    return `${pad(h)} : ${pad(mi)} : ${pad(s)}`
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    withSort?: boolean,
    sortName?: string,
    sortGap?: string
  ): HeaderObject {
    return {
      title: <string>title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
      withSort,
      sortName,
      sortStyle: {
        marginLeft: sortGap,
      },
    }
  }

  private tableCellMapper(value: unknown, colWidth: string): DataObject {
    const customStyle = {
      maxWidth: colWidth,
      minWidth: colWidth,
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const o = value as DataObject
      return {
        ...o,
        customStyle: { ...customStyle, ...o.customStyle },
      } as DataObject
    }
    return {
      value: value as string | number,
      customStyle,
    }
  }

  public handleExportPickupList(): void {
    const params = {
      file_name: `${this.statusId}-${Utils.formatDateWithIDLocale(
        new Date().toISOString(),
        'YYYYMMDDHHmss'
      )}`,
      date_from: Utils.formatDate(dayjs().subtract(1, 'week'), 'YYYY-MM-DD'),
      keyword: this.parameters.search || undefined,
      shipmentType: <string>(
        this.parameters.shipmentType
          ?.map(
            type =>
              this.shipmentTypeOptions.find(option => option.label === type)
                ?.value
          )
          .join(',')
      ),
      pickupDuration: encodeURIComponent(
        <string>this.parameters.pickupDuration?.value
      ),
    }

    if (!this.parameters.search) {
      delete params.keyword
    }

    controller.exportCRROTW(<Record<string, string | number | boolean>>params)
  }

  public syncData(): void {
    this.fetchPickups(true, true)
  }

  public onSort(sortObj: SortValueObject): void {
    this.parameters.sort = sortObj

    this.fetchPickups(true)
  }

  public isCrrotwTimeSortDirection(direction: 'ASC' | 'DESC'): boolean {
    return (
      this.parameters.sort.name === SortFieldsCRROTWV2.LAST_UPDATED &&
      this.parameters.sort.direction === direction
    )
  }

  public onCrrotwTimeHeaderSort(): void {
    const sortName = SortFieldsCRROTWV2.LAST_UPDATED
    const cur = this.parameters.sort
    if (!cur.direction && !cur.name) {
      this.onSort({ direction: 'ASC', name: sortName })
    } else if (sortName === cur.name) {
      if (cur.direction === 'ASC') {
        this.onSort({ direction: 'DESC', name: sortName })
      } else if (cur.direction === 'DESC') {
        this.onSort({ direction: 'ASC', name: sortName })
      }
    } else {
      this.onSort({ direction: 'ASC', name: sortName })
    }
  }

  @Watch('controller.pickupCRROTWV2Data', { deep: true })
  private onPickupCRROTWDataChange(pickup: PickupCRROTWV2List): void {
    const offset = (this.parameters.page - 1) * this.parameters.perPage
    this.tableData = <ITableCell[][]>pickup.data?.map((g, index) => {
      const primaryId = g.shipments[0]?.shipmentId ?? ''
      const posCode = (g.agent?.code || '').replace(/^["']+|["']+$/g, '').trim()
      const posLabel = posCode
        ? `[${posCode}] ${g.agent?.name || ''}`.trim()
        : (g.agent?.name || '—')
      const crrotwDate = Utils.formatDateWithIDLocale(g.createdAt, 'DD MMM YYYY')
      const crrotwTime = `${Utils.formatDateWithIDLocale(
        g.createdAt,
        'HH:mm'
      )} WIB`
      const rowNo = offset + index + 1
      const isCorp = isCorporateCrrotwShipmentType(g.shipmentType)

      const rowKey = this.getRowKey(g)

      return [
        this.tableCellMapper({ taskGroupId: g.taskGroupId, rowKey }, '44px'),
        this.tableCellMapper(String(rowNo), '60px'),
        this.tableCellMapper(
          {
            senderName: g.senderName,
            senderPhone: g.senderPhone,
            shipperHash: g.shipperHash,
            sampleShipmentId: primaryId,
            taskGroupId: g.taskGroupId,
            executionPlatform: g.executionPlatform,
            isPriority: g.isPriority,
          },
          '200px'
        ),
        this.tableCellMapper(
          {
            taskGroupId: g.taskGroupId,
            totalShipments: g.totalShipments,
            totalQuantity: g.totalQuantity,
          },
          '200px'
        ),
        this.tableCellMapper({
          senderAddress: g.senderAddress,
          latitude: g.latitude,
          longitude: g.longitude,
          shipperHash: g.shipperHash,
          sampleShipmentId: primaryId,
          taskGroupId: g.taskGroupId
        }, '260px'),
        this.tableCellMapper(this.shipmentTypeLabel(g.shipmentType), '190px'),
        this.tableCellMapper(posLabel, '190px'),
        this.tableCellMapper(
          {
            courierId: g.courier.id,
            courierName: g.courier.name,
            courierPhone: g.courier.phoneNumber,
            sampleShipmentId: primaryId,
            shipperHash: g.shipperHash,
            taskGroupId: g.taskGroupId,
            executionPlatform: g.executionPlatform
          },
          '225px'
        ),
        this.tableCellMapper(
          {
            crrotwDate,
            crrotwTime,
            expiredAt: g.expiredAt,
          },
          '180px'
        ),
        this.tableCellMapper(
          this.formatCrrotwDurationMinutes(g.durationShpcrtCrrotwMinute),
          '210px'
        ),
        this.tableCellMapper(
          this.formatCrrotwDurationMinutes(g.durationCrrsrcCrrotwMinute),
          '300px'
        ),
        this.tableCellMapper(
          {
            taskGroupId: g.taskGroupId,
            shipmentType: g.shipmentType,
            isCorporate: isCorp,
            primaryShipmentId: primaryId,
            executionPlatform: g.executionPlatform
          },
          '96px'
        ),
      ]
    })
    this.pagination = pickup.pagination
    const valid = new Set((pickup.data ?? []).map(g => this.getRowKey(g)))
    this.selectedRowKeys = this.selectedRowKeys.filter(k =>
      valid.has(k)
    )
  }

  async onExport(): Promise<void> {
    // this.controller.getExportPickup('/pickup-otw/export')
    const fileName = `${this.statusId}-${Utils.formatDateWithIDLocale(
      dayjs(),
      'YYYYMMDDHHmss'
    )}`
    const dateFrom = dayjs()
      .subtract(1, 'week')
      .format('YYYY-MM-DD')
    this.controller.setExportCRROTWLoading(true)
    this.controller
      .getExportPickup(
        new ExportPickupRequest({
          statusId: 'CRROTW',
          route: '/pickup-otw/export',
          payload: Utils.toInstance(
            new Map(),
            JSON.stringify({
              fileName,
              dateFrom,
              originCountry: this.isMyWhitelist ? 'Malaysia' : ''
            }),
            'snake_case'
          ),
        })
      )
      .finally(() => {
        this.controller.setExportCRROTWLoading(false)
      })
  }

  // ponytail: mirrors CRRNFDV2 eye-toggle; reveals via adminContactShow
  async showPhoneNumber(
    resource: string,
    resourceId: string,
    field: string,
    taskGroupId: number,
    type: string,
    sampleShipmentId?: string
  ): Promise<void> {
    try {
      const resp = await this.controller.adminContactShow({
        resource: resource,
        resourceId: resourceId,
        field: field,
        source: 'pickup_otw_v2'
      })
      const list = (this.controller.pickupCRROTWV2Data.data ?? []).map((item) => {
        const isTarget = taskGroupId > 0
          ? item.taskGroupId === taskGroupId
          : (sampleShipmentId ? item.shipments?.[0]?.shipmentId === sampleShipmentId : false)
        if (isTarget) {
          if (type === 'senderPhone') {
            item.senderPhone = resp.value || '-'
          } else if (type === 'senderAddress') {
            item.senderAddress = resp.value || '-'
          } else if (type === 'courierPhone') {
            item.courier.phoneNumber = resp.value || 'revealed'
          }
        }
        return item
      })
      this.controller.pickupCRROTWV2Data.data = list
    } catch {
      if (type === 'courierPhone') {
        const list = (this.controller.pickupCRROTWV2Data.data ?? []).map((item) => {
          const isTarget = taskGroupId > 0
            ? item.taskGroupId === taskGroupId
            : (sampleShipmentId ? item.shipments?.[0]?.shipmentId === sampleShipmentId : false)
          if (isTarget) {
            item.courier.phoneNumber = 'revealed'
          }
          return item
        })
        this.controller.pickupCRROTWV2Data.data = list
      }
    } finally {
      // no loading
    }
  }

  hidePhoneNumber(taskGroupId: number, type: string, sampleShipmentId?: string): void {
    const list = (this.controller.pickupCRROTWV2Data.data ?? []).map((item) => {
      const isTarget = taskGroupId > 0
        ? item.taskGroupId === taskGroupId
        : (sampleShipmentId ? item.shipments?.[0]?.shipmentId === sampleShipmentId : false)
      if (isTarget) {
        if (type === 'senderPhone') {
          item.senderPhone = ''
        } else if (type === 'senderAddress') {
          item.senderAddress = ''
        } else if (type === 'courierPhone') {
          item.courier.phoneNumber = ''
        }
      }
      return item
    })
    this.controller.pickupCRROTWV2Data.data = list
  }
}
export default PickupCRROTWPage;
